import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import Dashboard from "@/pages/Dashboard";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import Demo from "@/pages/Demo";
import ClipShare from "@/pages/ClipShare";
import CreatorSite from "@/pages/CreatorSite";
import YanaHub from "@/pages/YanaHub";
import YanaAdmin from "@/pages/YanaAdmin";
import PublicShow from "@/pages/PublicShow";
import PublicSettings from "@/pages/PublicSettings";
import Discover from "@/pages/Discover";
import Manage from "@/pages/Manage";
import Pricing from "@/pages/Pricing";
import { UpgradeModal } from "@/components/UpgradeModal";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";

function Protected() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="grid h-screen place-items-center bg-background text-accent">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }
  return user ? <Dashboard /> : <Login />;
}

// On a creator's own custom domain (e.g. barthandfriends.com), the site root shows their page.
const IS_BRANDED_HOST = !/clip-miner|emergent|localhost|127\.0\.0\.1|vercel|netlify/i.test(window.location.hostname);
const BRANDED_HANDLE = "barth";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/demo" element={<Demo />} />
      <Route path="/c/:clipId" element={<ClipShare />} />
      <Route path="/u/:handle" element={<CreatorSite />} />
      <Route path="/u/:handle/yana" element={<YanaHub />} />
      <Route path="/s/:showId" element={<PublicShow />} />
      <Route path="/public-settings" element={<PublicSettings />} />
      <Route path="/discover" element={<Discover />} />
      <Route path="/manage" element={<Manage />} />
      <Route path="/yana-admin" element={<YanaAdmin />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/" element={IS_BRANDED_HOST ? <CreatorSite forcedHandle={BRANDED_HANDLE} /> : <Protected />} />
      <Route path="*" element={<Protected />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <UpgradeModal />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" richColors />
    </div>
  );
}

export default App;
